import { IconClose, IconLoading } from 'components/icons';
import { AnimatePresence, motion } from 'framer-motion';
import {
  ARTICLE,
  ArticleData,
  ArticleEntity,
  ArticleVariables,
} from 'graphql/blog/queries/article';
import { useFlexQuery } from 'hooks';
import { toString } from 'lodash';

interface Props {
  selectedArticle?: ArticleEntity;
  onClose?: () => void;
}

const ArticleModal = ({ selectedArticle, onClose }: Props) => {
  const { id, attributes } = selectedArticle ?? {};
  const { title: articleTitle, slug, featured_media } = attributes ?? {};
  const { url: mediaUrl } = featured_media?.data?.attributes ?? {};

  const { data: articleData, loading: articleLoading } = useFlexQuery<
    ArticleData,
    ArticleVariables
  >('blog', ARTICLE, {
    variables: {
      slug: toString(slug),
    },
    skip: !slug,
  });
  const { article: articleDetail } = articleData ?? {};
  const { attributes: attributesDetail } = articleDetail?.data ?? {};
  const { content } = attributesDetail ?? {};

  const close = () => {
    onClose?.();
  };

  return selectedArticle ? (
    <div id='article-modal' className='relative'>
      <motion.div
        layoutId={`article-${selectedArticle.id}`}
        className='max-h-[calc(100vh-80px)] w-[calc(100vw-200px)] max-w-[900px] overflow-y-auto rounded-[16px]'
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type='button'
          className='absolute top-[18px] right-[18px] z-10 w-fit rounded-[8px] bg-[#000000]/[.5] p-[4px]'
          onClick={close}
        >
          <IconClose className='min-h-[32px] min-w-[32px] text-paper' />
        </button>
        <motion.img
          layoutId={`article-image-${id}`}
          src={mediaUrl ?? '/images/error-404.svg'}
          alt={articleTitle}
          className='h-[500px] w-full bg-paper object-cover'
        />
        <motion.div layoutId={`article-content-${id}`} />
        <div className='space-y-[20px] bg-paper p-[20px]'>
          <motion.h1
            layoutId={`article-title-${id}`}
            className='whitespace-pre-wrap text-[32px] font-[600] leading-[40px] text-service-text'
          >
            {articleTitle ?? ''}
          </motion.h1>
          <AnimatePresence>
            {articleLoading ? (
              <div className='flex justify-center py-[40px]'>
                <IconLoading className='min-h-[44px] min-w-[44px] animate-spin text-stroke' />
              </div>
            ) : (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                dangerouslySetInnerHTML={{ __html: toString(content) }}
                className='blog-content blog-content-desktop whitespace-pre-wrap'
              />
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  ) : null;
};

export default ArticleModal;
